const managerAssistChat = {
  container: 'ManagerAssistChat-Container',
  chatWindow: 'ManagerAssistChat-Window',
  header: {
    title: 'ManagerAssistChat-Header-Title',
    closeButton: 'ManagerAssistChat-Header-CloseButton',
  },
  welcomeScreen: {
    container: 'ManagerAssistChat-WelcomeScreen-Container',
    title: 'ManagerAssistChat-WelcomeScreen-Title',
    description: 'ManagerAssistChat-WelcomeScreen-Description',
    getStartedButton: 'ManagerAssistChat-WelcomeScreen-GetStartedButton',
  },
  chat: {
    content: 'ManagerAssistChat-Chat-Content',
    messageInput: 'ManagerAssistChat-Chat-MessageInput',
    sendButton: 'ManagerAssistChat-Chat-SendButton',
    loadingIndicator: 'ManagerAssistChat-Chat-LoadingIndicator',
    errorMessage: 'ManagerAssistChat-Chat-ErrorMessage',
    retryButton: 'ManagerAssistChat-Chat-RetryButton',
  },
  suggestions: {
    container: 'ManagerAssistChat-Suggestions-Container',
    suggestion: 'ManagerAssistChat-Suggestions-Item',
  },
  messages: {
    userMessage: 'ManagerAssistChat-Messages-UserMessage',
    assistantMessage: 'ManagerAssistChat-Messages-AssistantMessage',
  },
} as const;

export const managerAssistChatLocators = {
  managerAssistChat,
} as const;
